import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Label,
  Form,
  FormGroup
} from "reactstrap";
import { connect } from "react-redux";
import { addItem } from "../../actions/unsubscribeListActions";

class FormModal extends Component {
  state = {
    modal: false,
    email: ""
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      radioUnsubscribe: "requestsOnly"
    })
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value});
  }

  onSubmit = (e) => {
    e.preventDefault();

    const newItem = {
    email: this.state.email,
    option: this.state.radioUnsubscribe
    }

    this.props.addItem(newItem);

    this.toggle();
  }

  render() {
    return(
      <div>
        <Button
          color="dark"
          style={{width: "100%"}}
          onClick={this.toggle}
        >
          Unsubscribe
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
        >
          <ModalHeader toggle={this.toggle}>
            Unsubscribe Form
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={this.onSubmit}>
              <FormGroup>
                <Label for="Email">Email</Label>
                <Input
                  type="text"
                  name="email"
                  id="item"
                  placeholder="example@email.com"
                  onChange={this.onChange}
                />
                </FormGroup>
                <FormGroup tag="fieldset">
                  <FormGroup check>
                    <Label check>
                      <Input type="radio" name="radioUnsubscribe" defaultChecked value="requestsOnly" onChange={this.onChange}/>{' '}
                      Unsubscribe from all requests
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="radio" name="radioUnsubscribe" value="all" onChange={this.onChange} />{' '}
                      Unsubscribe from all requests and updates
                    </Label>
                  </FormGroup>
                </FormGroup>
                <Button
                  color="dark"
                  style={{marginTop: "2rem"}}
                  block
                >
                  Submit
                </Button>
            </Form>
          </ModalBody>

        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  item: state.item
});

export default connect(mapStateToProps, { addItem })(FormModal);
